export default __webpack_public_path__ + "static/media/Anne.045bffcb.png";